import type { ApiType as ApiTypeEnum, IApiTypeServerType } from '@/shared/constant/ApiType';
import { FoxIconRepeat, FoxIconWebhook } from 'aui-biz-icons';
import clsx from 'clsx';
import { memo } from 'react';
import { ApiMethodIconSize } from '../../type/ApiMethodIconSize';

export type ApiType = IApiTypeServerType | ApiTypeEnum.Callback;

type ApiLabelProps = {
  size: ApiMethodIconSize;
  apiType: ApiType;
  className?: string;
};

const LabelMap: Partial<Record<ApiType, { name: string; icon: React.FC<{ className?: string }> }>> =
  {
    callback: {
      name: 'Callback',
      icon: memo(function CallbackIcon() {
        return <FoxIconRepeat />;
      }),
    },
    webhook: {
      name: 'Webhook',
      icon: memo(function WebhookIcon() {
        return <FoxIconWebhook />;
      }),
    },
  };

export const ApiLabel = memo(function ApiLabelComponent({ size, apiType }: ApiLabelProps) {
  const LabelIcon = LabelMap[apiType]?.icon;
  return (
    LabelMap[apiType] && (
      <div
        className={clsx({
          ['mr-1 flex h-[24px] items-center justify-center rounded-md bg-blue-1 px-1.5 py-[2px] text-sm font-600 text-blue-6']:
            size === ApiMethodIconSize.Large,
        })}
      >
        {LabelIcon && <LabelIcon />}
        {size === ApiMethodIconSize.Large && <span className="ml-1">{LabelMap[apiType].name}</span>}
      </div>
    )
  );
});
